import { jsx as j } from "react/jsx-runtime";
import { forwardRef as P } from "react";
import W from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as B } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { I as C } from "./helperText-d9646f54.mjs";
import { TextInput as G } from "./textInput.js";
import "./index-65016bfa.mjs";
import "./_commonjsHelpers-92157f1b.mjs";
import "./icon.js";
import "@fcamna/shared-icons";
import "./label-33699561.mjs";
import "./popupTip.js";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./Aria-f5e019e2.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./button.js";
import "./useAccessibilityProps-2f24cf29.mjs";
import "./setup-0f23222d.mjs";
import "./table.js";
import "./uniqueId-321287e8.mjs";
import "./closeButton.js";
import "./iconButton.js";
import "./divider.js";
import "./focusTrap.js";
import "./useClient-0bbce34e.mjs";
import "./getElementPosition-a8642645.mjs";
import "./link.js";
import "./tooltip.js";
const R = "Credit/Debit Card Number", h = "1234 1234 1234 1234", k = /.{1,4}/g, U = "[0-9s]{13,19}", H = "2", J = "5", V = "4", v = "3", m = "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNTc2IDM3NyIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4gICAgICAgIDx0aXRsZT5wbGFjZWhvbGRlcjwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9InBsYWNlaG9sZGVyIj4gICAgICAgICAgICA8cGF0aCBkPSJNNTI3LjkzMzc5MywzNzYuOTk4MjggTDQ4LjA2NjIwNjksMzc2Ljk5ODI4IEMzNS40MjM0ODAzLDM3Ny4xMDM5NjggMjMuMjU2NTg2NCwzNzIuMTg3ODkgMTQuMjQyMzI4MSwzNjMuMzMxNjE4IEM1LjIyODA2OTc1LDM1NC40NzUzNDYgMC4xMDQ5MTcxMDIsMzQyLjQwNDQwNyAwLDMyOS43NzQ0OTQgTDAsNDcuMjI1NDU1NCBDMC4xMDQ5MTcxMDIsMzQuNTk1NTQyNSA1LjIyODA2OTc1LDIyLjUyNDYwNCAxNC4yNDIzMjgxLDEzLjY2ODMzMTkgQzIzLjI1NjU4NjQsNC44MTIwNTk4NSAzNS40MjM0ODAzLC0wLjEwNDAxODI5NiA0OC4wNjYyMDY5LDAuMDAxNjY5NDg2NDYgTDUyNy45MzM3OTMsMC4wMDE2Njk0ODY0NiBDNTQwLjU3NjUyLC0wLjEwNDAxODI5NiA1NTIuNzQzNDE0LDQuODEyMDU5ODUgNTYxLjc1NzY3MiwxMy42NjgzMzE5IEM1NzAuNzcxOTMsMjIuNTI0NjA0IDU3NS44OTUwODMsMzQuNTk1NTQyNSA1NzYsNDcuMjI1NDU1NCBMNTc2LDMyOS45NzI5MTMgQzU3NS42NzI3ODYsMzU2LjE5NTY2MyA1NTQuMTg0MjczLDM3Ny4yMTg4NTcgNTI3LjkzMzc5MywzNzYuOTk4MjggWiIgaWQ9InNoYXBlIiBmaWxsPSIjRThFQkVFIiBmaWxsLXJ1bGU9Im5vbnplcm8iPjwvcGF0aD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlIiBzdHJva2U9IiM3NTc1NzUiIHN0cm9rZS13aWR0aD0iMjAiIHg9IjQxOCIgeT0iNTgiIHdpZHRoPSI5MSIgaGVpZ2h0PSI2MyIgcng9IjMwIj48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSI1MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtMiIgZmlsbD0iIzc1NzU3NSIgeD0iNDEzIiB5PSIyMDgiIHdpZHRoPSIxMDciIGhlaWdodD0iNDAiIHJ4PSI4Ij48L3JlY3Q+ICAgICAgICAgICAgPHJlY3QgaWQ9IlJlY3RhbmdsZS0yIiBmaWxsPSIjNzU3NTc1IiB4PSIyOTMiIHk9IjIwOCIgd2lkdGg9IjEwNyIgaGVpZ2h0PSI0MCIgcng9IjgiPjwvcmVjdD4gICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTIiIGZpbGw9IiM3NTc1NzUiIHg9IjE3MyIgeT0iMjA4IiB3aWR0aD0iMTA3IiBoZWlnaHQ9IjQwIiByeD0iOCI+PC9yZWN0PiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+", F = "data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0idmlzYSI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRjZGOUZDIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iI0Y5OUYxQiIgZD0iTTAgMTZ2LjYzQTIuNCAyLjQgMCAwIDAgMi40MiAxOWgyNC4xNkEyLjQgMi40IDAgMCAwIDI5IDE2LjYyVjE2SDB6Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMyRDQ5OTAiIGQ9Ik0wIDN2LS42M0EyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzhWM0gwem0xMy45IDMuMTJsLTEuNDggNi43N2gtMS43N2wxLjQ2LTYuNzdoMS43OHptNy40NyA0LjM4bC45NC0yLjU1LjU0IDIuNTVoLTEuNDh6bTEuOTkgMi40SDI1bC0xLjQ0LTYuNzhoLTEuNTFhLjguOCAwIDAgMC0uNzYuNWwtMi42NyA2LjI3aDEuODdsLjM3LTFoMi4yOGwuMjIgMXptLTQuNjQtMi4yMmMwLTEuNzgtMi41MS0xLjg4LTIuNS0yLjY4LjAxLS4yNC4yNS0uNS43Ni0uNTdhMy40IDMuNCAwIDAgMSAxLjc1LjNsLjMxLTEuNDNjLS40Mi0uMTUtLjk3LS4zLTEuNjYtLjMtMS43NiAwLTMgLjkyLTMgMi4yNC0uMDEuOTcuODggMS41MiAxLjU1IDEuODQuNy4zMy45My41NS45My44NC0uMDEuNDYtLjU2LjY2LTEuMDcuNjYtLjkuMDItMS40MS0uMjMtMS44Mi0uNDJsLS4zMyAxLjQ4Yy40Mi4xOSAxLjE5LjM1IDEuOTguMzYgMS44NyAwIDMuMDktLjkgMy4xLTIuMzJ6bS03LjM3LTQuNTZMOC40NyAxMi45SDYuNkw1LjE4IDcuNWMtLjA5LS4zMy0uMTctLjQ1LS40My0uNkE3LjUzIDcuNTMgMCAwIDAgMyA2LjMzbC4wNC0uMmgzLjAzYy4zOCAwIC43My4yNi44Mi43bC43NSAzLjkxIDEuODUtNC42aDEuODZ6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+", X = "data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0ibWFzdGVyY2FyZCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgMikiPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjMDAzNjYzIiBkPSJNMjYuNTggMTlIMi40MkEyLjQgMi40IDAgMCAxIDAgMTYuNjJWMi4zOEEyLjQgMi40IDAgMCAxIDIuNDIgMGgyNC4xNkEyLjQgMi40IDAgMCAxIDI5IDIuMzh2MTQuMjVBMi40IDIuNCAwIDAgMSAyNi41OCAxOXoiLz4gICAgICAgIDxjaXJjbGUgaWQ9InNoYXBlIiBjeD0iMTAuNSIgY3k9IjkuNSIgcj0iNi41IiBmaWxsPSIjRUIxQzI2Ii8+ICAgICAgICA8Y2lyY2xlIGlkPSJzaGFwZSIgY3g9IjE4LjUiIGN5PSI5LjUiIHI9IjYuNSIgZmlsbD0iI0Y5OUYxQiIvPiAgICAgICAgPHBhdGggaWQ9InNoYXBlIiBmaWxsPSIjRUY1RDIwIiBkPSJNMTQuNSA0LjM4YTYuNDkgNi40OSAwIDAgMCAwIDEwLjI0IDYuNDkgNi40OSAwIDAgMCAwLTEwLjI0eiIvPiAgICAgIDwvZz4gICAgPC9nPiAgPC9nPjwvc3ZnPg==", _ = "data:image/svg+xml;base64,PHN2ZyBmb2N1c2FibGU9ImZhbHNlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAyMSI+ICA8ZyBpZD0iUGFnZS0xIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICA8ZyBpZD0iYW1leCI+ICAgICAgPGcgaWQ9ImNhcmQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xIDIpIj4gICAgICAgIDxwYXRoIGlkPSJzaGFwZSIgZmlsbD0iIzFEOTFDRSIgZD0iTTI3LjU4IDE5SDMuNDJBMi40IDIuNCAwIDAgMSAxIDE2LjYyVjIuMzhBMi40IDIuNCAwIDAgMSAzLjQyIDBoMjQuMTZBMi40IDIuNCAwIDAgMSAzMCAyLjM4djE0LjI1QTIuNCAyLjQgMCAwIDEgMjcuNTggMTl6Ii8+ICAgICAgICA8cG9seWxpbmUgaWQ9InNoYXBlIiBmaWxsPSIjRkZGRkZGIiBwb2ludHM9IjUuMDYzIDExLjg5NiA0LjU5MSAxMyAuMzYgMTMgMy42OTkgNiAxMS42NzQgNiAxMi40NzkgNy41NDYgMTMuMjMxIDYgMTYuMDY0IDYgMTcuNDkyIDYgMjMuOTgzIDYgMjQuOTAyIDYuOTYxIDI1Ljg4OSA2IDMwLjg4MiA2IDI3LjMzNyA5LjQ5MiAzMC43MjkgMTMgMjUuODk3IDEzIDI0LjgxNiAxMS45NjkgMjMuNzQ0IDEzIDE3LjQ5MiAxMyAxNi4wNjQgMTMgNi40OTYgMTMgNS45NzcgMTEuODk2Ii8+ICAgICAgICA8cGF0aCBpZD0ic2hhcGUiIGZpbGw9IiMxRDkxQ0UiIGQ9Ik01Ljk4IDExLjk3aC0uOTIuOTJ6TTE2LjIgN2gtMi4xbC0xLjU4IDMuMzVMMTAuODIgN2gtMi4xdjQuODVMNi41NSA3SDQuNThsLTIuMzIgNWgxLjQybC40Ny0xLjE0aDIuN0w3LjM5IDEySDEwVjcuOTNMMTEuODUgMTJoMS4yMmwxLjg0LTR2NGgxLjI5Vjd6bTguNjcgMS42MkwyMy4zNyA3aC02LjAydjVIMjMuMTdsMS42NS0xLjY0TDI2LjQ4IDEyaDEuNTVsLTIuMzctMi41M0wyOC4xIDdoLTEuNjJsLTEuNjEgMS42MnpNMjEuNyAxMWgtMy4wNlY5LjloMy4wNlY4LjloLTMuMDZWOGgzLjA2di0uODVsMi4yNyAyLjI3LTIuMjcgMi4yOFYxMXpNNS41MyA3LjgybC44OCAyLjAzSDQuNThsLjk1LTIuMDN6Ii8+ICAgICAgPC9nPiAgICA8L2c+ICA8L2c+PC9zdmc+", f = W.div`
  ${({ $textSize: I, ...M }) => I === "small" ? `
        --svg-wrapper-width-global: ${M.theme.components.creditCardInput.Wrapper["--svg-wrapper-width-global"].small};
        --svg-wrapper-height-global: ${M.theme.components.creditCardInput.Wrapper["--svg-wrapper-height-global"].small};
      ` : `
        --svg-wrapper-width-global: ${M.theme.components.creditCardInput.Wrapper["--svg-wrapper-width-global"].default};
        --svg-wrapper-height-global:  ${M.theme.components.creditCardInput.Wrapper["--svg-wrapper-height-global"].default};
      `}

  && input {
    width: ${(I) => I.theme.components.creditCardInput.Wrapper.input.width};
  }
  && input:not([disabled])::placeholder {
    color: ${(I) => I.theme.components.creditCardInput.Wrapper.inputNotDisabledPlaceholder.color};
  }

  && input:disabled::placeholder {
    color: ${(I) => I.theme.components.creditCardInput.Wrapper.inputDisabledPlaceholder.color};
  }
`, $ = (I) => {
  if (!I)
    return I;
  const M = I.match(k);
  return M == null ? void 0 : M.join(" ");
};
let i = m;
const a = (I) => {
  if (I && I.length > 0)
    switch (I[0]) {
      case H:
      case J:
        i = X;
        return;
      case V:
        i = F;
        return;
      case v:
        i = _;
        return;
    }
  i = m;
}, r = () => /* @__PURE__ */ j(
  "img",
  {
    alt: "Credit card image",
    src: i
  }
), ZI = P(
  ({
    iconAlignment: I = "right",
    textSize: M = "medium",
    value: g = "",
    onBlur: y,
    onChange: t,
    pattern: o = U,
    autoComplete: e = "cc-number",
    // Credit and debit cards tend to have a total of 16 digits printed on the front,
    // though a card can have as many as 19 digits or as little as 13.
    // 13 to 19 digits plus white space separators
    maxLength: d = 23,
    minLength: S = 14,
    placeholder: z = h,
    isRequired: s = !1,
    required: u = s,
    label: p,
    showErrorIcon: K = !1,
    showRequiredIndicator: l = u,
    labelProp: x,
    infoProp: n,
    trailingText: E,
    helperText: N,
    isInvalid: A = !1,
    helperTextProp: w = {
      ...N && !A && { defaultProp: { helperText: N } },
      ...A && {
        secondaryProp: { helperText: N, state: "error" }
      }
    },
    inputState: L,
    ...Q
  }, Z) => {
    const Y = B({ label: "Credit Card Input" });
    let c = L || C.NONE;
    L || (c = A ? C.ERROR : C.NONE), a(g == null ? void 0 : g.toString());
    const O = (D) => {
      const T = D.target.value.replace(/\D/g, "");
      a(T);
      const b = $(T) ?? "";
      D.target.value = b, t && t(D);
    };
    return /* @__PURE__ */ j(
      f,
      {
        $textSize: M,
        ...Y,
        children: /* @__PURE__ */ j(
          G,
          {
            value: g == null ? void 0 : g.toString(),
            type: "tel",
            inputMode: "numeric",
            pattern: o,
            autoComplete: e,
            maxLength: d,
            minLength: S,
            placeholder: z,
            textSize: M,
            required: u,
            endAdornment: I === "right" ? r() : void 0,
            startAdornment: I === "left" ? r() : void 0,
            onChange: O,
            onBlur: y,
            ref: Z,
            labelProp: {
              showRequiredIndicator: l,
              label: p || R,
              ...x
            },
            infoProp: { ...n },
            trailingText: E,
            inputState: c,
            helperTextProp: w,
            ...Q
          }
        )
      }
    );
  }
);
export {
  ZI as CreditCardInput
};
